import script from "./Huonekortti.vue?vue&type=script&setup=true&lang=ts"
export * from "./Huonekortti.vue?vue&type=script&setup=true&lang=ts"

import "./Huonekortti.vue?vue&type=style&index=0&id=e3d65590&lang=css"

const __exports__ = script;

export default __exports__